/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = ComponentType, 1 = Assembly, 2 = Package
 */
export enum StepScope {
    ComponentType = 0,
    Assembly = 1,
    Package = 2
}

